<template>
  <div>
    <ReturnBtn
      :path="this.path ? this.path : `subskrypcja`"
      blackColor
    ></ReturnBtn>
    <h1 class="section-title" style="text-align: center; margin-top: 40px">
      {{ selectedVideo ? selectedVideo.name : course ? course.name : "" }}
    </h1>
    <div v-if="!selectedVideo.timePackageId" class="register-buttons">
      <a href="#" class="login" @click="changeVersion()"
        ><span class="logbtn" :class="{ active: selectedVersion !== 'FULL' }"
          >Darmowa wersja</span
        >
      </a>
      <span class="or">/</span>
      <a href="#" class="register"
        ><span class="logbtn" :class="{ active: selectedVersion === 'FULL' }"
          >Pełny dostęp</span
        ></a
      >
    </div>
    <v-row class="card">
      <!-- <div class="switch" v-if="!selectedVideo.timePackageId">
        <div
          :class="{ selectedSwitch: selectedVersion === 'DEMO' }"
          class="demo btn-gradient"
          @click="changeVersion()"
        >
          Demo
        </div>
        <div
          :class="{ selectedSwitch: selectedVersion === 'FULL' }"
          class="full-video btn-gradient"
        >
          Pełna wersja
        </div>
      </div> -->

      <v-col v-if="selectedVersion === 'FULL'">
        <video-player
          :videoId="getCourseYoutubeId()"
          :dropboxLink="getDropboxLink"
        />
      </v-col>
      <div class="text-under">
        <p
          v-html="
            selectedVideo
              ? htmlToFormattedText(selectedVideo.description)
              : htmlToFormattedText(course.description)
          "
        ></p>
      </div>
    </v-row>
    <CommentSection :id="selectedVideo.id" />
  </div>
</template>

<script>
import ReturnBtn from "../components/ReturnBtn.vue";
import VideoPlayer from "../components/VideoPlayer.vue";
import CommentSection from "../components/CommentSection.vue";
import { getYoutubeIdFromUrl } from "../utils";

export default {
  name: "WorkshopsVideos",

  components: {
    ReturnBtn,
    VideoPlayer,
    CommentSection,
  },
  props: {
    course: Object,
  },

  data: () => ({
    playing: true,
    path: "",
    loggedIn: false,
    selectedVersion: "FULL",
  }),
  mounted() {},

  async created() {
    if (this.$route.params.path) {
      this.path = this.$route.params.path;
    }
    await this.$store.dispatch(`auth/checkUserActiveSubscriptions`);
    const token = window.localStorage.getItem("userToken");
    if (token) {
      this.loggedIn = true;
    }
  },

  methods: {
    htmlToFormattedText(text) {
      const regex =
        /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g;
      text = text.replace(regex, '<a href="$1">$1</a>');
      return text;
    },
    changeVersion() {
      this.$router.push({ name: "VideosDemo" });
    },
    getDemoCourseYoutubeId() {
      let courseLink;
      if (this.selectedVideo) {
        courseLink = this.selectedVideo.demoLink;
      } else if (this.course) {
        courseLink = this.course.demoLink;
      } else {
        return "";
      }
      return getYoutubeIdFromUrl(courseLink);
    },
    getCourseYoutubeId() {
      let courseLink;
      if (this.selectedVideo) {
        courseLink = this.selectedVideo.link;
      } else if (this.course) {
        courseLink = this.course.link;
      } else {
        return "";
      }

      return getYoutubeIdFromUrl(courseLink);
    },

    moveToAuth() {
      this.$router.push({
        name: "Auth",
        params: { previousPage: "WorkshopsVideos" },
      });
    },
    moveToSubscriptions() {
      this.$router.push({ name: "TimeSubscriptions" });
    },
  },

  computed: {
    getDropboxLink() {
      let courseLink;
      if (this.selectedVideo) {
        courseLink = this.selectedVideo.linkDropbox;
      } else if (this.course) {
        courseLink = this.course.linkDropbox;
      } else {
        return "";
      }

      const videoLink = courseLink ? courseLink.replace("dl=0", "raw=1") : "";
      return videoLink;
    },

    selectedVideo() {
      return this.$store.getters["videos/getSelectedVideo"];
    },
    timePackageItems() {
      let courses = this.$store.getters["timePackages/getTimePackageItems"];
      return courses;
    },
    hasActiveSubscription() {
      return this.$store.getters["auth/getHasActiveSubscription"];
    },
  },
};
</script>

<style scoped>
.card {
  width: 70vw;
  margin: 0 auto;
  display: block;
  position: relative;
  color: #54514c;
  position: relative;
  margin: auto;
  margin-top: 30px;
}
.text-under {
  padding: 20px 30px;
}
h3 {
  margin-bottom: 20px;
  font-size: 1.3rem;
  font-weight: 400;
}

.no-access .btn-gradient {
  width: 220px;
  padding: 8px 22px;
  border-radius: 30px;
  font-size: 1rem;
  margin: 15px;
}
.no-access {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  padding-top: 3rem;
  height: 100%;
  min-height: 300px;
  max-height: 600px;
  width: 80%;
  margin: 0 auto;
  background-image: url("../assets/background-video.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.switch {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
}
.switch div {
  padding: 1rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  font-size: 15px;
  cursor: pointer;
}
.switch .btn-gradient {
  height: 40px;
  display: flex;
  align-items: center;
  background: rgb(233, 230, 230);
  color: black;
}
.switch .btn-gradient:hover {
  transform: none;
}
.selectedSwitch {
  background: rgb(179, 106, 103) !important;
  background: linear-gradient(
    90deg,
    rgba(179, 106, 103, 1) 0%,
    rgba(223, 44, 38, 1) 100%
  ) !important;
  color: #fff !important;
}
@media screen and (max-width: 700px) {
  .card {
    width: 90vw;
  }
}
@media screen and (max-width: 550px) {
  .no-access h3 {
    font-size: 1.1rem;
  }
}
@media screen and (max-width: 450px) {
  .no-access .btn-gradient {
    font-size: 0.8;
    width: 160px;
  }
  .no-access h3 {
    font-size: 1rem;
  }
  .card {
    width: 100vw;
  }
  .text-under {
    font-size: 0.8rem;
    padding: 20px 5px;
  }
}
@media screen and (max-width: 375px) {
  .no-access h3 {
    font-size: 0.8rem;
  }
}

.register-buttons {
  display: flex;
  margin: 10px auto;
  margin-top: 30px;
  width: fit-content;
  background: #d9d9d9;
  padding: 10px 15px;
  border-radius: 30px;
}
.logbtn {
  color: #6d6963;
  font-size: 24px;
  opacity: 0.7;
  transition: 0.5s all ease;
}
.logbtn:hover {
  opacity: 1;
}

.or {
  font-size: 24px;
  color: #6d6963;
  padding: 0 10px;
}
a {
  text-decoration: none;
}

@media screen and (max-width: 500px) {
  .logbtn {
    font-size: 18px;
  }
  .or {
    font-size: 18px;
  }
}
</style>
